export const VUEX_PHOTOS_FETCH = 'VUEX_PHOTOS_FETCH'
export const VUEX_PHOTOS_FETCH_SUCCESS = 'VUEX_PHOTOS_FETCH_SUCCESS'
export const VUEX_PHOTOS_FETCH_FAILURE = 'VUEX_PHOTOS_FETCH_FAILURE'

export const VUEX_PHOTOS_STATE_UPDATE = 'VUEX_PHOTOS_STATE_UPDATE'

export const VUEX_PHOTOS_CLEAR = 'VUEX_PHOTOS_CLEAR'

export const VUEX_PHOTOS_FETCH_NEXT_PAGE = 'VUEX_PHOTOS_FETCH_NEXT_PAGE'
